import {ServerApi} from "./ServerApi.js";
import {DateTime} from "@intermesh/goui";

export function ifwLog(moduleName: string, message: string) {
	const url = ServerApi.url('log/create');
	let dt = new DateTime(), amsdt = null;
	let f = dt.format("Y-m-d H:i:s");
	if (dt.timezone !== "UTC") {
		amsdt = dt.toTimezone("UTC");
		f = amsdt.format("Y-m-d H:i:s");
	}
	const p = {
		// data: {
			type: "error",
			description: message,
			userAgent: window.navigator.userAgent,
			moduleName: moduleName,
			createdAt: f
		// }
	};
	ServerApi.call(url, p, "POST").then(()=> {

	}).catch((msg: string) => {
		console.log("Could not save log on server");
		console.error(msg);
	});
}